export enum LeaveRequestSource {
  INDO = 'INDO',
  JAPAN = 'JAPAN',
}
